export function timer(now) {
    var st = now();
    return function stop() {
        return Math.round(now() - st);
    };
}
